// import axios from "axios";
import { create } from "zustand";

const appstore = create((set, get) => ({
  isLogin: false,
  adminLogin: false,
  isSubscribed: false,
  menu: "",
  readmoreContent: "",
  userData: {},
  setUserData: (data) => {
    set({ userData: data });
  },
  setUserlogin: (data) => {
    set({ isLogin: data });
  },
  setSubscribeEmail: (data) => {
    set({ isSubscribed: data });
  },
  setMenu: (data) => {
    set({ menu: data });
  },
  setReadmoreContent: (data) => {
    set({ readmoreContent: data });
  },
}));
export default appstore;
